module.exports = __webpack_public_path__ + "static/media/data4.0a86f23d.jpg";